import React from 'react';
import {
    Card,
    Typography,
    Space,
    Tag,
    Descriptions,
    Divider,
    Popover,
    Tooltip
} from '@douyinfe/semi-ui';

import Statistic from '../../../comp/CustomStatistic';

import {
    IconCoinMoneyStroked,
    IconCheckCircleStroked,
    IconPercentage,
    IconCalendar,
    IconBarChartHStroked,
    IconIdCard,
    IconMoneyExchangeStroked,
    IconHelpCircle
} from '@douyinfe/semi-icons';
import { formatAmountZhCn,renderStatDetailContentPlan, formatDate,   } from "../../../utils";

const { Text, Title } = Typography;

interface ReleaseSummaryProps {
    summary: {
        totalLoanAmount: number;
        totalPaidAmount: number;
        totalInterest: number;
        totalCommission: number;
        loanCount: number;
        planCount: number;
    };
    interestResult?: any;
    loanPlans?: any[];
}

const ReleaseSummary: React.FC<ReleaseSummaryProps> = ({
    summary,
    interestResult,
    loanPlans
}) => {

    const statDataObj = React.useMemo(() => {
        if (!loanPlans || loanPlans.length === 0) return null;
        const result: any = {
            loanAmount: 0,
            cardAmount: 0,
            borrowAmount: 0,
            loanRepaymentPlanAmount: 0,
            loanHelpRepaymentPlanAmount: 0,
            cardRepaymentPlanAmount: 0,
            cardHelpRepaymentPlanAmount: 0,
            cardPostingPlanAmount: 0,
            cardHelpPostingPlanAmount: 0,
            borrowReturnAmount: 0,
        };
        loanPlans.forEach(loan => {
            result.loanAmount += loan.loanAmount || 0;
            result.cardAmount += loan.cardAmount || 0;
            result.borrowAmount += loan.borrowAmount || 0;
            result.loanRepaymentPlanAmount += loan.loanRepaymentPlanAmount || 0;
            result.loanHelpRepaymentPlanAmount += loan.loanHelpRepaymentPlanAmount || 0;
            result.cardRepaymentPlanAmount += loan.cardRepaymentPlanAmount || 0;
            result.cardHelpRepaymentPlanAmount += loan.cardHelpRepaymentPlanAmount || 0;
            result.cardPostingPlanAmount += loan.cardPostingPlanAmount || 0;
            result.cardHelpPostingPlanAmount += loan.cardHelpPostingPlanAmount || 0;
            result.borrowReturnAmount += loan.borrowReturnAmount || 0;
        });
        return result;
    }, [loanPlans]);

    

    return (
        <Card className="release-summary">
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <Title heading={5} style={{ margin: 0 }}>
                    释放汇总
                </Title>
                {statDataObj && (
                    <Popover
                        content={renderStatDetailContentPlan(statDataObj)}
                        trigger="hover"
                        position="bottomLeft"
                        showArrow
                    >
                        <a style={{ marginLeft: 12, whiteSpace: 'nowrap', color: 'var(--semi-color-link)', cursor: 'pointer' }}>
                            <IconBarChartHStroked style={{marginRight: 4}}/>统计详情
                        </a>
                    </Popover>
                )}
            </div>

            <Descriptions layout='horizontal'>
                <Descriptions.Item itemKey="贷款笔数">
                    <Tag color="blue" size="large">
                        {summary.loanCount}笔
                    </Tag>
                </Descriptions.Item>
                <Descriptions.Item itemKey="计划总数">
                    <Tag color="green" size="large">
                        {summary.planCount}个
                    </Tag>
                </Descriptions.Item>
                
            </Descriptions>

            <Divider />

            <Space align="start" spacing={12}>
                <Statistic
                    title="总贷款金额"
                    value={summary.totalLoanAmount}
                    prefix={<IconCoinMoneyStroked />}
                    groupSeparator
                    precision={0}
                    suffix="元"
                    valueStyle={{ color: 'var(--semi-color-danger)' }}
                />

                <Statistic
                    title="总已还金额"
                    value={summary.totalPaidAmount}
                    prefix={<IconCheckCircleStroked />}
                    groupSeparator
                    precision={0}
                    suffix="元"
                    valueStyle={{ color: 'var(--semi-color-success)' }}
                />

                {statDataObj && (
                    <>
                        
                        <Statistic
                            title={
                                <Tooltip content="出款金额 = 贷款代还 + 信用卡代还 + 借款金额">
                                    出款金额 <IconHelpCircle style={{ color: '#eb2f96' }} />
                                </Tooltip>
                            }
                            value={statDataObj.loanHelpRepaymentPlanAmount+statDataObj.cardHelpRepaymentPlanAmount
                                +statDataObj.borrowAmount}
                            prefix={<IconCoinMoneyStroked />}
                            groupSeparator
                            precision={0}
                            suffix="元"
                            valueStyle={{ color: '#eb2f96' }}
                        />
                    </>
                )}
            </Space>

            <Divider />

            {(summary.totalInterest > 0 || summary.totalCommission > 0) && (
                <div className="interest-section">
                    <Title heading={6} style={{ marginBottom: 12 }}>
                        费用计算
                    </Title>

                    <Space vertical={false} align="start" spacing={8}>
                        <div className="statistic-item">
                            <IconCoinMoneyStroked style={{ color: 'var(--semi-color-warning)' }} />
                            <Text style={{ margin: '0 8px',width:'60px' }}>总利息：</Text>
                            <Text style={{ fontSize: '24px' }} strong type="warning">
                                {formatAmountZhCn(summary.totalInterest)}
                            </Text>
                        </div>

                        <div className="statistic-item">
                            <IconCoinMoneyStroked style={{ color: 'var(--semi-color-success)' }} />
                            <Text style={{ margin: '0 8px' }}>总抽佣：</Text>
                            <Text style={{ fontSize: '24px' }} strong type="success">
                                {formatAmountZhCn(summary.totalCommission)}
                            </Text>
                        </div>


                    </Space>
                </div>
            )}


        </Card>
    );
};

export default ReleaseSummary;